import React from 'react';
import * as css from './WhatsAppEditorHeader.css';
import WhatsAppEditorWarningBadges from '../whatsAppEditorWarningBadges/WhatsAppEditorWarningBadges';

interface WhatsAppEditorHeaderProps {
    totalCharacters: number;
    filledParagraphsCount: number;
    totalParagraphsCount: number;
    hasDisabledVariables: boolean;
    toolbarExtra: React.ReactNode;
}

function WhatsAppEditorHeader({
    totalCharacters,
    filledParagraphsCount,
    totalParagraphsCount,
    hasDisabledVariables,
    toolbarExtra,
}: WhatsAppEditorHeaderProps) {
    return (
        <css.headerBar data-cy="whatsapp-editor-header">
            <WhatsAppEditorWarningBadges
                totalCharacters={totalCharacters}
                filledParagraphsCount={filledParagraphsCount}
                totalParagraphsCount={totalParagraphsCount}
                hasDisabledVariables={hasDisabledVariables}
            />
            {toolbarExtra}
        </css.headerBar>
    );
}

export default WhatsAppEditorHeader;
